














import {FieldType} from "../Form";
import TextField from "./TextField.vue";
import TextareaField from "./TextareaField.vue";
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import generateRandomID from "../generateRandomID";

const componentsMap: Record<string, any> = {
    [FieldType.text]: TextField,
    [FieldType.textarea]: TextareaField
}

@Component
export default class FormField extends Vue {
    @Prop() field: any | undefined;
    @Prop() value: any | undefined;
    @Prop() error: any | undefined;
    @Prop() messages: any[] | undefined;
    randomID: string = generateRandomID()

    getFieldComponent(field: any) {
        return componentsMap[field.type];
    }
}
